<template>
  <div>
    <br><br><br>
    <h4>{{symbol}}</h4>
    <div v-for="(data, index) in rootData" :key="index">
      {{layouts[index].title}}
      <Plotly :data="data" :layout="layout" :display-mode-bar="true"></Plotly>
    </div>
    <table class="default">
      <tr>
        <th>fecha entry</th>
        <th>fecha exit </th>
        <th>diff</th>
        <th>percentDiff</th>
        <th>type</th>
        <th>cumValue</th>
        <th>time</th>
        <th>security</th>
      </tr>
      <tr v-for="(data, index) in tradeData" :key="index">
        <td>{{data.entry.timeString}}</td>
        <td>{{data.exit.timeString}}</td>
        <td>{{data.priceDiff}}</td>
        <td>{{data.percentDiff}}</td>
        <td>{{data.currentType}}</td>
        <td>{{data.cumValue}}</td>
        <td>{{data.days}}</td>
        <td>{{data.security}}</td>
      </tr>
    </table>
    <h3>{{this.percentProfit}}</h3>
  </div>
</template>
<script>
import { Plotly } from 'vue-plotly'
import { historicalc, getOpertions } from '../services/multiSnifferService'
export default {
  components: {
    Plotly
  },
  data: () => ({
    layouts: [],
    rootData: [],
    selectData: [],
    jojo: [],
    dataJson: null,
    tradeData: null,
    symbol: '',
    layout: {
      title: 'My graph'
    }
  }),
  async mounted () {
    await this.loadData()
    this.processData(0)
    this.getTradeData()
  },
  methods: {
    onChange (e) {
      this.processData(e.target.value)
    },
    async loadData () {
      var urlString = window.location.href
      console.log(urlString, 'url-string')
      var url = new URL(urlString)
      this.symbol = url.searchParams.get('symbol')
      var data = await historicalc(this.symbol, 1)
      console.log(data)
      this.dataJsonc = data.data
      data = await historicalc(this.symbol, 24)
      this.dataJsonc24 = data.data
      data = await historicalc(this.symbol, 48)
      this.dataJsonc48 = data.data
      var ops = await getOpertions(this.symbol)
      this.ops = ops.data
    },
    getTradeData () {
      var init = 100
      var value = init
      this.tradeData = this.ops
      for (let current of this.tradeData) {
        value = value * (1 + (current.percentDiff / 100))
        current.cumValue = value
      }
      this.Profit = value
      this.percentProfit = ((value - init) / init) * 100
    },
    processData (index) {
      let dataArray = []
      let data = []
      data.push({
        y: this.dataJsonc.map(item => item.avg),
        x: this.dataJsonc.map(item => item.timeString),
        name: 'c',
        type: 'line'
      })
      data.push({
        y: this.dataJsonc24.map(item => item.avg),
        x: this.dataJsonc24.map(item => item.timeString),
        name: 'avg24',
        type: 'line'
      })
      data.push({
        y: this.dataJsonc48.map(item => item.avg),
        x: this.dataJsonc48.map(item => item.timeString),
        name: 'avg48',
        type: 'line'
      })
      dataArray.push({ data, title: `${this.symbol} C HISTORY` })
      this.layouts = dataArray.map(item => ({title: item.title, xaxis: {type: 'date'}}))
      this.rootData = dataArray
    }
  }

}

</script>

<style>
.container{
  padding-top: 5%;
}

.chart-container {
  position: relative;
  margin: auto;
  height: 50vh !important;
  width: 80vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chartHistory.vue